import React from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// form fields
import AppFormikRadio from 'utlis/helpers/forms/AppFormikRadio'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'

export default function RelatedProductsTab(props) {
    // props
    const {
        formik
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* btns */}
                    <div className="btns d-flex flex-wrap align-items-center mb-3">
                        <button className="st-btn st-btn-white-gray-outlined st-btn-sm d-flex align-items-center text-capitalize">
                            <span className="round-feather-icon-outlined hoverable d-inline-flex align-items-center justify-content-center me-2">
                                <FeatherIcon
                                    icon="plus"
                                    size="10"
                                    className="icon cursor-pointer" />
                            </span>
                            <span>Assign Products</span>
                        </button>
                        <p className="ms-auto st-fs-13 st-text-color2">Drag and drop items to sort</p>

                        {/* <div className="w-100 mt-2">
                            <p className="ms-auto st-fs-13 st-text-color2">These files will be available to the customers once the order recieves status pad.</p>
                        </div> */}
                    </div>

                    <div className="files-table page-border-box">
                        <div className="ft-inner pbb-inner table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th width="50" className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </th>
                                        <th width="150">SKU</th>
                                        <th>Name</th>
                                        <th width="75">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-sku text-color">
                                                AAA-37-082
                                            </p>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-sku text-color">
                                                AAA-37-082
                                            </p>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-sku text-color">
                                                AAA-37-082
                                            </p>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-sku text-color">
                                                AAA-37-082
                                            </p>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="">
                                        <td className="text-center">
                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                // defaultChecked={item.status ? true : false}
                                                // onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                />
                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="14"
                                                        className="icon" />
                                                </span>
                                            </label>
                                        </td>

                                        <td>
                                            <p className="file-sku text-color">
                                                AAA-37-082
                                            </p>
                                        </td>

                                        <td>
                                            <p className="file-name st-text-primary">
                                                logo_backup_file_new_2x_small.png
                                                <span className="st-text-color ms-2">(33.06kb)</span>
                                            </p>
                                        </td>

                                        <td>
                                            <div className="btns d-flex justify-content-center">
                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="15"
                                                        className="icon" />
                                                </button>

                                                <button
                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                >
                                                    <FeatherIcon
                                                        icon="more-vertical"
                                                        size="15"
                                                        className="icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="other-options">
                        <div className="d-flex align-items-center">
                            {/* heading */}
                            <p className="box-heading st-fs-15 st-fw-600 st-text-color me-3">Display random products</p>
                            {/* form field */}
                            <AppFormikRadio
                                formik={formik} // formik object
                                labelClass={"align-items-center mb-0"} // class name for main wrapper
                                checkedText={"Enabled"} // name when the radio is checked
                                unCheckedText={"Disabled"} // name when the radio is checked
                                // isRequired={true} // is this field is required or not to show the red star sign
                                formikFieldName={"isFeatured"} // important: formik value name for the input
                            />
                        </div>

                        <div className="add-files-form-fields">
                            <div className="inner d-flex">
                                {/* form field */}
                                <div className="item">
                                    <AppFormikInputInline
                                        inputType={"number"}
                                        formik={formik} // formik object
                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center qty-field no-arrows"} // class name for main wrapper
                                        labelName={"Qty"} // label name
                                        // isRequired={true} // is this field is required or not to show the red star sign
                                        placeholder={"Qty"} // placeholder for the input
                                        formikFieldName={"blogTitle"} // important: formik value name for the input
                                    />
                                </div>

                                {/* form field */}
                                <div className="item media-body">
                                    <AppFormikInputInline
                                        inputType={"text"}
                                        formik={formik} // formik object
                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center product-from-category no-arrows"} // class name for main wrapper
                                        labelName={"Random Product From category"} // label name
                                        // isRequired={true} // is this field is required or not to show the red star sign
                                        placeholder={"Random Product From category"} // placeholder for the input
                                        formikFieldName={"blogTitle"} // important: formik value name for the input
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
